export default class OrganizationItemModel {
  value: string;
  label: string;

  constructor(data: any) {
    this.value = data.id || undefined;
    this.label = data.name || undefined;
  }
}
